import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FadeIn } from '../components/FadeIn';
import  useTheme  from '../context/ThemeContext';

export const TermosUso = () => {
  const { isDark } = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      id: 'aceitacao',
      title: '1. Aceitação dos Termos',
      content: `Ao acessar e utilizar os serviços da Atende24h ("Serviços"), você concorda em cumprir e estar vinculado a estes Termos de Uso ("Termos"). Se você não concordar com qualquer parte destes termos, não deverá utilizar nossos serviços.

Estes Termos constituem um contrato juridicamente vinculante entre você e a Atende24h, inscrita no CNPJ [XX.XXX.XXX/0001-XX], com sede em [endereço completo].`
    },
    {
      id: 'servicos',
      title: '2. Descrição dos Serviços',
      content: `A Atende24h oferece soluções tecnológicas incluindo:`,
      items: [
        {
          subtitle: '2.1. Automação de Atendimento',
          text: 'Integração de WhatsApp Business com plataformas como Chatwoot, N8N, Evolution API e Typebot para automação de comunicação.'
        },
        {
          subtitle: '2.2. Softwares SaaS',
          text: 'Desenvolvimento de sistemas web sob medida para gestão de obras de engenharia civil e locação de equipamentos.'
        },
        {
          subtitle: '2.3. Consultoria Técnica',
          text: 'Serviços de consultoria em arquitetura de software, integração de sistemas e automação de processos.'
        }
      ],
      extra: 'Reservamo-nos o direito de modificar, suspender ou descontinuar qualquer serviço, total ou parcialmente, a qualquer momento, com ou sem aviso prévio.'
    },
    {
      id: 'cadastro',
      title: '3. Cadastro e Conta',
      content: `Para utilizar nossos serviços, você deve:`,
      items: [
        { text: 'Ter pelo menos 18 anos de idade ou ser representante legal de pessoa jurídica' },
        { text: 'Fornecer informações verdadeiras, precisas, atuais e completas durante o cadastro' },
        { text: 'Manter e atualizar prontamente os dados de cadastro' },
        { text: 'Ser responsável por manter a confidencialidade de suas credenciais de acesso' },
        { text: 'Assumir total responsabilidade por todas as atividades realizadas em sua conta' }
      ],
      note: 'A Atende24h se reserva o direito de recusar serviços, encerrar contas ou remover conteúdo a seu critério exclusivo.'
    },
    {
      id: 'pagamento',
      title: '4. Pagamento e Faturamento',
      content: `Condições financeiras:`,
      items: [
        {
          subtitle: '4.1. Preços',
          text: 'Os valores dos serviços estão descritos em nossa página de preços ou propostas comerciais específicas. Preços podem ser alterados com 30 dias de aviso prévio.'
        },
        {
          subtitle: '4.2. Faturamento',
          text: 'Pagamentos são processados mensalmente via boleto bancário, cartão de crédito ou PIX, conforme escolha do cliente.'
        },
        {
          subtitle: '4.3. Cancelamento',
          text: 'O cliente pode cancelar a assinatura a qualquer momento. Não realizamos reembolsos proporcionais, exceto nos casos previstos em lei.'
        },
        {
          subtitle: '4.4. Inadimplência',
          text: 'Serviços podem ser suspensos após 5 dias de atraso no pagamento. Reativação sujeita a taxa de reestabelecimento.'
        }
      ]
    },
    {
      id: 'propriedade',
      title: '5. Propriedade Intelectual',
      content: `Direitos de propriedade intelectual:`,
      items: [
        {
          subtitle: '5.1. Nossa Propriedade',
          text: 'Todo o software, código-fonte, interfaces, algoritmos e materiais fornecidos pela Atende24h são de nossa propriedade exclusiva, protegidos por leis de direitos autorais e propriedade intelectual.'
        },
        {
          subtitle: '5.2. Licença de Uso',
          text: 'Concedemos a você uma licença limitada, não exclusiva, não transferível e revogável para usar nossos serviços conforme estes Termos.'
        },
        {
          subtitle: '5.3. Seu Conteúdo',
          text: 'Você mantém a propriedade de seus dados e conteúdo. Ao utilizarmos nossos serviços, você nos concede uma licença para processar esses dados exclusivamente para prestação dos serviços contratados.'
        },
        {
          subtitle: '5.4. Código Customizado',
          text: 'Para projetos de desenvolvimento sob medida, a propriedade do código será definida em contrato específico (work-made-for-hire ou licenciamento).'
        }
      ]
    },
    {
      id: 'uso-proibido',
      title: '6. Uso Proibido',
      content: `Você concorda em NÃO utilizar nossos serviços para:`,
      items: [
        { text: 'Violar leis, regulamentos ou direitos de terceiros' },
        { text: 'Enviar spam, mensagens não solicitadas ou realizar phishing' },
        { text: 'Distribuir malware, vírus ou qualquer código malicioso' },
        { text: 'Tentar acessar não autorizado a sistemas ou redes' },
        { text: 'Usar os serviços para atividades fraudulentas ou ilegais' },
        { text: 'Interferir na integridade ou performance dos serviços' },
        { text: 'Extrair dados ou realizar scraping sem autorização' },
        { text: 'Revender, sublicenciar ou comercializar nossos serviços sem autorização' },
        { text: 'Violar os Termos de Serviço do WhatsApp ou outras plataformas integradas' }
      ],
      note: 'Violações podem resultar em suspensão imediata, encerramento de conta e responsabilização legal.'
    },
    {
      id: 'whatsapp',
      title: '7. Termos Específicos - WhatsApp',
      content: `Ao utilizar nossos serviços de automação WhatsApp:`,
      items: [
        { text: 'Você concorda em cumprir os Termos de Serviço do WhatsApp Business e Políticas Comerciais da Meta' },
        { text: 'É proibido usar números pessoais do WhatsApp para atividades comerciais em larga escala' },
        { text: 'Mensagens devem seguir as diretrizes de templates aprovados quando usando API Oficial' },
        { text: 'Taxas de mensagens da Meta são de responsabilidade do cliente' },
        { text: 'A Atende24h não se responsabiliza por bloqueios de números devido a uso indevido pelo cliente' },
        { text: 'Recomendamos uso de API Oficial para volumes superiores a 1000 mensagens/dia' }
      ],
      extra: 'Reservamo-nos o direito de suspender serviços que violem as políticas da Meta para proteger nossa infraestrutura e outros clientes.'
    },
    {
      id: 'limitacao',
      title: '8. Limitação de Responsabilidade',
      content: `Na máxima extensão permitida por lei:`,
      items: [
        { text: 'Nos eximimos de qualquer responsabilidade por danos indiretos, incidentais, especiais, consequenciais ou punitivos' },
        { text: 'Nossa responsabilidade total por quaisquer reivindicações não excederá o valor pago por você nos 12 meses anteriores ao evento' },
        { text: 'Não garantimos que os serviços serão ininterruptos, livres de erros ou seguros' },
        { text: 'Não somos responsáveis por falhas causadas por fatores fora de nosso controle (força maior, atos de terceiros, falhas de internet)' }
      ],
      note: 'Estas limitações não se aplicam em casos de dolo ou negligência grave, nem afetam direitos que não podem ser limitados conforme a lei aplicável.'
    },
    {
      id: 'indemnizacao',
      title: '9. Indenização',
      content: `Você concorda em indenizar, defender e isentar a Atende24h, seus diretores, funcionários e agentes de quaisquer reivindicações, responsabilidades, danos, perdas e despesas (incluindo honorários advocatícios razoáveis) decorrentes de:

- Seu uso dos serviços
- Violação destes Termos
- Violação de direitos de terceiros
- Conteúdo transmitido através de nossos serviços`
    },
    {
      id: 'rescisao',
      title: '10. Rescisão',
      content: `Podemos encerrar ou suspender seu acesso imediatamente, sem aviso prévio ou responsabilidade, por qualquer motivo, incluindo violação destes Termos.

Após rescisão:`,
      items: [
        { text: 'Seu direito de usar os serviços cessará imediatamente' },
        { text: 'Seus dados podem ser excluídos conforme nossa Política de Privacidade' },
        { text: 'Disposições que por natureza deverão sobreviver à rescisão permanecerão em vigor' },
        { text: 'Valores devidos até a data de rescisão permanecem exigíveis' }
      ]
    },
    {
      id: 'geral',
      title: '11. Disposições Gerais',
      content: `Estes Termos são regidos pelas leis da República Federativa do Brasil.

Qualquer disputa será resolvida no foro da comarca de [cidade/estado], com renúncia a qualquer outro, por mais privilegiado que seja.

Se qualquer disposição destes Termos for considerada inválida ou inexequível, as demais disposições permanecerão em pleno vigor e efeito.

Nossa falha em fazer cumprir qualquer direito ou disposição destes Termos não constituirá renúncia a tal direito ou disposição.

Estes Termos, juntamente com nossa Política de Privacidade, constituem o acordo integral entre você e a Atende24h.`
    },
    {
      id: 'contato-termos',
      title: '12. Contato',
      content: `Para questões sobre estes Termos de Uso, entre em contato:

**Atende24h**
- E-mail: juridico@atende24h.com.br
- Endereço: [Endereço completo]
- Telefone: (62) 99470-7272

Responderemos em até 10 dias úteis.`
    }
  ];

  const lastUpdate = '04 de Fevereiro de 2026';

  return (
    <div style={{ 
      marginTop: '80px',
      background: 'var(--bg-primary)',
      minHeight: '100vh',
    }}>
      {/* Header */}
      <section style={{
        padding: '4rem 0',
        background: isDark 
          ? 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
          : 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)',
      }}>
        <div className="container">
          <FadeIn>
            <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.5rem 1rem',
                  background: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '30px',
                  color: '#94a3b8',
                  fontSize: '0.85rem',
                  marginBottom: '1.5rem',
                }}
              >
                <i className="fas fa-file-contract"></i>
                Documento Legal
              </motion.div>

              <h1 style={{
                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                fontWeight: 800,
                color: 'white',
                marginBottom: '1rem',
              }}>
                Termos de Uso
              </h1>

              <p style={{ color: '#94a3b8', fontSize: '1.1rem', marginBottom: '1rem' }}>
                Condições e regras para utilização de nossos serviços
              </p>

              <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
                <i className="fas fa-calendar-alt" style={{ marginRight: '0.5rem' }}></i>
                Última atualização: {lastUpdate}
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* Alerta Importante */}
      <div style={{
        background: isDark ? 'rgba(245, 158, 11, 0.1)' : '#fffbeb',
        border: '1px solid',
        borderColor: isDark ? 'rgba(245, 158, 11, 0.3)' : '#f59e0b',
        padding: '1.5rem',
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '1rem',
            maxWidth: '900px',
            margin: '0 auto',
          }}>
            <i className="fas fa-exclamation-triangle" style={{ 
              color: '#f59e0b', 
              fontSize: '1.5rem',
              marginTop: '0.25rem',
            }}></i>
            <div>
              <h3 style={{ 
                color: isDark ? '#fbbf24' : '#92400e', 
                marginBottom: '0.5rem',
                fontSize: '1.1rem',
              }}>
                Importante
              </h3>
              <p style={{ 
                color: isDark ? '#fcd34d' : '#78350f', 
                margin: 0,
                fontSize: '0.95rem',
                lineHeight: 1.6,
              }}>
                Ao utilizar nossos serviços, você declara que leu, entendeu e concorda com estes Termos de Uso e nossa 
                <Link to="/privacidade" style={{ 
                  color: 'var(--primary)', 
                  textDecoration: 'underline',
                  marginLeft: '0.25rem',
                }}>
                  Política de Privacidade
                </Link>.
                Recomendamos a leitura cuidadosa antes de contratar qualquer serviço.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Navegação Rápida */}
      <div style={{
        background: 'var(--bg-secondary)',
        borderBottom: '1px solid var(--border-color)',
        position: 'sticky',
        top: '80px',
        zIndex: 100,
        backdropFilter: 'blur(10px)',
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            gap: '1rem',
            padding: '1rem 0',
            overflowX: 'auto',
            scrollbarWidth: 'none',
          }}>
            {sections.map((section) => (
              <a
                key={section.id}
                href={`#${section.id}`}
                style={{
                  padding: '0.5rem 1rem',
                  background: 'var(--bg-tertiary)',
                  color: 'var(--text-secondary)',
                  borderRadius: '20px',
                  fontSize: '0.85rem',
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  border: '1px solid var(--border-color)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'var(--primary)';
                  e.target.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'var(--bg-tertiary)';
                  e.target.style.color = 'var(--text-secondary)';
                }}
              >
                {section.title.split('. ')[1]}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Conteúdo */}
      <section style={{ padding: '4rem 0' }}>
        <div className="container">
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            {sections.map((section, idx) => (
              <FadeIn key={section.id} delay={idx * 0.05}>
                <motion.div
                  id={section.id}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  style={{
                    marginBottom: '3rem',
                    padding: '2rem',
                    background: 'var(--card-bg)',
                    borderRadius: '16px',
                    border: '1px solid var(--border-color)',
                  }}
                >
                  <h2 style={{
                    fontSize: '1.5rem',
                    color: 'var(--text-primary)',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                  }}>
                    <span style={{
                      width: '32px',
                      height: '32px',
                      background: 'var(--primary)',
                      color: 'white',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.875rem',
                      fontWeight: 700,
                    }}>
                      {section.title.split('.')[0]}
                    </span>
                    {section.title.split('. ')[1]}
                  </h2>

                  <div style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    <p style={{ marginBottom: '1rem' }}>{section.content}</p>

                    {section.items && (
                      <ul style={{ listStyle: 'none', padding: 0, margin: '1.5rem 0' }}>
                        {section.items.map((item, iidx) => (
                          <motion.li
                            key={iidx}
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ delay: iidx * 0.1 }}
                            style={{
                              padding: '1rem',
                              marginBottom: '0.75rem',
                              background: 'var(--bg-tertiary)',
                              borderRadius: '8px',
                              borderLeft: '3px solid var(--primary)',
                            }}
                          >
                            {item.subtitle && (
                              <h4 style={{ 
                                color: 'var(--text-primary)', 
                                marginBottom: '0.5rem',
                                fontSize: '1rem',
                              }}>
                                {item.subtitle}
                              </h4>
                            )}
                            <p style={{ margin: 0, fontSize: '0.95rem' }}>{item.text}</p>
                          </motion.li>
                        ))}
                      </ul>
                    )}

                    {section.note && (
                      <div style={{
                        padding: '1rem',
                        background: 'rgba(239, 68, 68, 0.1)',
                        border: '1px solid rgba(239, 68, 68, 0.2)',
                        borderRadius: '8px',
                        marginTop: '1rem',
                      }}>
                        <i className="fas fa-exclamation-circle" style={{ color: '#ef4444', marginRight: '0.5rem' }}></i>
                        <span style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>{section.note}</span>
                      </div>
                    )}

                    {section.extra && (
                      <p style={{ 
                        marginTop: '1rem', 
                        padding: '1rem',
                        background: 'var(--bg-tertiary)',
                        borderRadius: '8px',
                        fontSize: '0.95rem',
                      }}>
                        {section.extra}
                      </p>
                    )}
                  </div>
                </motion.div>
              </FadeIn>
            ))}

            {/* Aceite e Assinatura */}
            <FadeIn>
              <motion.div
                whileHover={{ scale: 1.01 }}
                style={{
                  padding: '2rem',
                  background: 'linear-gradient(135deg, var(--primary), var(--accent))',
                  borderRadius: '16px',
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                <i className="fas fa-signature" style={{ fontSize: '3rem', marginBottom: '1rem' }}></i>
                <h3 style={{ marginBottom: '0.5rem' }}>Concorda com estes termos?</h3>
                <p style={{ opacity: 0.9, marginBottom: '1.5rem' }}>
                  Para utilizar nossos serviços, é necessário aceitar integralmente estes Termos de Uso.
                </p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Link to="/contato" style={{
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: 'var(--primary)',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: 600,
                  }}>
                    Contratar Serviço
                  </Link>
                  <Link to="/privacidade" style={{
                    padding: '0.75rem 1.5rem',
                    background: 'rgba(255,255,255,0.2)',
                    color: 'white',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    border: '1px solid rgba(255,255,255,0.3)',
                  }}>
                    Ver Política de Privacidade
                  </Link>
                </div>
              </motion.div>
            </FadeIn>

            {/* Links Relacionados */}
            <FadeIn>
              <div style={{
                marginTop: '3rem',
                padding: '2rem',
                background: 'var(--bg-secondary)',
                borderRadius: '16px',
                border: '1px solid var(--border-color)',
              }}>
                <h4 style={{ color: 'var(--text-primary)', marginBottom: '1rem' }}>Documentos Relacionados</h4>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                  <Link to="/privacidade" style={{
                    padding: '1rem',
                    background: 'var(--card-bg)',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    color: 'var(--text-primary)',
                    border: '1px solid var(--border-color)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                  }}>
                    <i className="fas fa-shield-alt" style={{ color: 'var(--primary)' }}></i>
                    Política de Privacidade
                  </Link>
                  <a href="#" style={{
                    padding: '1rem',
                    background: 'var(--card-bg)',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    color: 'var(--text-primary)',
                    border: '1px solid var(--border-color)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                  }}>
                    <i className="fas fa-cookie-bite" style={{ color: 'var(--secondary)' }}></i>
                    Política de Cookies
                  </a>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </div>
  );
};